<template>
    <video
        controls=""
        :poster="poster ?? ''"
        @click="gaEventVideo(props.name)"
    >
        <source
            :src="props.url"
            type="video/mp4"
        >
    </video>
</template>

<script setup lang="ts">
const props = defineProps(['poster', 'url', 'name']);
const {gtag} = useGtag();
function gaEventVideo(name: string) {
    gtag('event', 'select_content', {content_type: 'Video', content_id: name});
    gtag('event', 'conversion', {send_to: 'AW-428666490/u1zNCLLvuOYYEPrcs8wB'});
}

</script>

<style scoped>

</style>
